import { FieldArray, useFormikContext } from "formik";
import React, { FC } from "react";
import {
  ICreateClubWizardForm,
  ICreateClubWizardProps,
} from "../../../../common/interfaces/clubs-wizard.interface";
import { removeItem } from "../../../../utilities/helpers";
import VotingThreshold from "../VotingThreshold/VotingThreshold";
import plusIcon from "../../../../assets/addCircle.svg";
import "./TradeApprovalConfiguration.scss";
import {
  EMPTY_STRING,
  MAX_TRADE_APPROVAL_QUORUM,
  SOL_SYMBOL,
} from "../../../../common/constants/common.constants";
import { GovernanceConfigurationType } from "../../../../common/enums/clubs-wizard.enum";

const TradeApprovalConfiguration: FC<ICreateClubWizardProps> = (formConfig) => {
  const { values } = useFormikContext<ICreateClubWizardForm>();

  const addItem = (arrayHelpers) => {
    arrayHelpers.push({
      to: EMPTY_STRING,
      from: EMPTY_STRING,
      approvalQuorum: EMPTY_STRING,
    });
  };

  const removeTradeApprovalQuorum = (index, arrayHelpers) => {
    removeItem(index, arrayHelpers);
  };
  return (
    <div className="trade-approval-config__voting-threshold">
      <p className="trade-approval-config__title">
        {values.governance !== GovernanceConfigurationType.ProjectFundraise &&
          "Trade &"}{" "}
        Transfer configuration
      </p>
      <p className="trade-approval-config__trade-description">
        Here you can set specific voting configurations for trades. If no
        specific ranges are set, default voting configurations will be used for
        all proposals.
      </p>
      <p className="trade-approval-config__trade-description">
        Decide on the price range that will require either a lower or higher
        approval vote percentage for specific proposals. You can configure this
        for less significant trades and reach the approval vote percentage more
        easily, or demand a 100% approval for trades that will affect your
        treasury in a greater extent.
      </p>
      <FieldArray
        validateOnChange
        name={formConfig.formFields.votingThreshold.name}
        render={(arrayHelpers) => {
          return (
            <div className="trade-approval-config__voting-item">
              {values.votingThreshold.map((member, index) => {
                return (
                  <VotingThreshold
                    name="votingThreshold"
                    removeItem={() =>
                      removeTradeApprovalQuorum(index, arrayHelpers)
                    }
                    index={index}
                    key={index}
                    mintSymbol={values.mintSymbol ?? SOL_SYMBOL}
                  />
                );
              })}

              {arrayHelpers.form.values.votingThreshold.length <
                MAX_TRADE_APPROVAL_QUORUM && (
                <button onClick={() => addItem(arrayHelpers)} type="button">
                  <img src={plusIcon} alt="Add new member" />
                  Add trading range
                </button>
              )}
            </div>
          );
        }}
      />
    </div>
  );
};

export default TradeApprovalConfiguration;
